<template>
  <div class="wait-inspect">
    <el-form :inline="true" :model="formInline" label-position="left" class="demo-form-inline">
      <el-form-item>
        <el-input maxlength='50' v-model="formInline.packCode" placeholder="输入组合处理编号" @keydown.native.enter="onSubmit"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input maxlength='50' v-model="formInline.platformOrderNo" placeholder="输入订单号" @keydown.native.enter="onSubmit"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 10px;text-align:left">
      <el-button type="primary" @click="createPack" :disabled="createFlag">导入PDA</el-button>
      <el-button type="primary" @click="openPkgVisible">批次设置</el-button>
    </div>
    <WmsTable :columns="inspectColumns" @pageChange="pageChangeCall" :dataSource="dataSource" :isPagination="query" :hasHeader=false
      :isExpanded_hidden="true" :isRowSelection="true" @selectChange="selChange" ref="wmsTable" rowKey="packCode">
      <!-- <template #action="{ record }">
        <a @click="getDetail(record)">详情</a>
      </template> -->
      <template #expandedRender="{ record }">
        <div>
          <WmsTable :columns="inspectRegionColumns" :dataSource="record.regionPickList" :isPagination="false" :hasHeader="false" :isExpanded_hidden="true" rowKey="rowKey">
            <template #expandedRender="{ record }">
              <WmsTable :columns="inspectGoodsColumns" :dataSource="record.itemDTOList" :hasHeader="false" :isPagination="false">
                <div slot="img" slot-scope="record_son">
                  <ImgPreviews :images="[record_son.text]"></ImgPreviews>
                </div>
              </WmsTable>
            </template>
          </WmsTable>
          <!-- <a-table :columns="inspectGoodsColumns" :dataSource="record.packItems" :pagination="false">
            <div slot="img" slot-scope="record_son">
              <ImgPreviews :images="[record_son]"></ImgPreviews>
            </div>
          </a-table> -->
        </div>
      </template>
    </WmsTable>

    <el-dialog title="待拣货详情" :visible.sync="dialogVisible">
      <detail ref="detail" @close="dialogVisible = false"></detail>
    </el-dialog>
    <el-dialog title="批次设置" :visible.sync="setPkgVisible" :destroy-on-close="true">
      <el-form :model="formInline" :rules="rules" ref="form">
        <el-form-item label="单批次组数上限：" prop="maxNum">
          <el-input v-model="formInline.maxNum" style="width:200px;float:left" ></el-input>
        </el-form-item>
      </el-form>
      <span style="color:red">说明文案：小于上限需分拣为一框一组，大于等于上限时分拣为一框多组</span>
      <template #footer>
        <div>
          <el-button type="primary" @click="setPkg">确定</el-button>
          <el-button @click="setPkgVisible = false">取消</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import WmsTable from "@/components/WmsTable";
import ImgPreviews from "@/components/ImgPreviews";
import detail from "./waitInspectDetail";
import { inspectColumns, inspectGoodsColumns,inspectRegionColumns } from "./combinTable";
import { Table } from "ant-design-vue";
import { packAbleTask, createPackBatch,updateCombinationPickConfig,getCombinationPickConfig } from "@/apis/combination";
export default {
  title: "待拣货",
  name: "waitInspect",
  components: {
    WmsTable,
    [Table.name]: Table,
    ImgPreviews,
    detail
  },
  data() {
    return {
      inspectColumns,
      inspectGoodsColumns,
      inspectRegionColumns,
      formInline: {},
      dataSource: [],
      selArray: [],
      params: {},
      query: {
        pageSize: 10,
        current: 1,
        total: 1,
      },
      dialogVisible: false,
      setPkgVisible: false,
      formInline:{
        maxNum:10
      },
      rules:{
        maxNum:[
          {required: true,trigger: 'blur',validator: (rule, value, callback)=>{
            if (!value) {
              callback(new Error('请输入单批次组数上限'));
            } else if(isNaN(value)){
              callback(new Error('请输入单批次组数上限'));
            }else if(value > 999 || value < 1){
              callback(new Error('单批次组数上限范围1~999'));
            }else{
              callback();
            }
          }}
        ]
      }
    };
  },
  computed: {
    createFlag: function () {
      return this.selArray.length == 0
    },
  },
  methods: {
    getList() {
      let params = {
        pageSize: this.query.pageSize,
        pageNum: this.query.current,
        ...this.formInline,
      }
      packAbleTask(params).then(({ code, data }) => {
        if (code === 0) {
          data.records.forEach((item) => {
            item.regionPickList.forEach((item_son) => {
              item_son.rowKey = item.packCode + item_son.regionName;
            });
          });
          this.dataSource = data.records;
          this.query.total = data.total
        }
      });
    },
    reset(){
      this.formInline = {};
      this.query = {
        pageSize: 10,
        current: 1,
        total: 1,
      };
      this.getList();
    },
    selChange(sel) {
      this.selArray = sel;
    },
    createPack() {
      if (!this.selArray.length) {
        this.$message.warning("请勾选任务");
        return;
      }
      let packCodes = [];
      this.selArray.forEach((item) => {
        packCodes.push(item.packCode);
      });
      createPackBatch(packCodes).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("导入成功");
          this.getList();
        }
      });
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getList();
    },
    onSubmit() {
      this.$refs.wmsTable.resetSel()
      this.query.current = 1
      this.getList();
    },
    restSubmit() {
      this.$refs.wmsTable.resetSel()
    },
    getDetail(record) {
      console.log(record);
      this.dialogVisible = true;
      this.$nextTick((_) => {
        this.$refs.detail.detail = record.packRecords;
      });
    },
    openPkgVisible(){
      getCombinationPickConfig().then(({code,data})=>{
        if( code == 0){
          this.formInline.maxNum = data
          this.setPkgVisible = true
        }
      })
    },
    setPkg(){
      this.$refs.form.validate((v)=>{
        if(v){
          updateCombinationPickConfig({value:this.formInline.maxNum}).then(({code,data})=>{
            if(code == 0 ){
              this.$message.success('成功')
              this.setPkgVisible = false
            }
          })
        }
      })
    }
  },
  created() { },
};
</script>
<style lang="less" scoped>
.demo-form-inline {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>
